export { DeviceHistoryListComponent } from '../components/device-history/device-history-list.component';
